import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import { format } from "date-fns";
import { fr, enUS } from "date-fns/locale";
import { useLanguage } from "../i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NewsDetail = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const { lang, t } = useLanguage();
  const tn = t.newsPage;
  const dateLocale = lang === "fr" ? fr : enUS;

  useEffect(() => {
    axios
      .get(`${API}/articles/${id}`)
      .then((res) => setArticle(res.data))
      .catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="min-h-[60vh] pt-32 pb-20 text-center bg-white" data-testid="news-detail-notfound">
        <p className="text-slate-500 font-light mb-8">{tn.empty}</p>
        <Link to="/actualites" className="text-[#2547a8] font-medium inline-flex items-center gap-2">
          <ArrowLeft size={16} /> {tn.back}
        </Link>
      </div>
    );
  }

  if (!article) {
    return <div className="min-h-[60vh] pt-32 bg-white" />;
  }

  return (
    <div data-testid="news-detail-page">
      {/* Bannière */}
      <section className="relative flex items-end min-h-[46vh] md:min-h-[54vh] overflow-hidden">
        {article.image ? (
          <img src={article.image} alt={article.title} className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <div className="absolute inset-0 bg-[#1b2653]" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#101733]/95 via-[#141d43]/60 to-[#141d43]/40" />
        <div className="relative z-10 max-w-4xl mx-auto px-5 lg:px-8 pb-14 pt-40 w-full">
          <div className="flex items-center gap-4 mb-4">
            {article.category && (
              <span className="bg-white text-[#1b2653] px-4 py-1.5 rounded-full text-[11px] font-semibold uppercase tracking-[0.18em]">
                {article.category}
              </span>
            )}
            <span className="text-white/70 text-sm">
              {tn.publishedOn} {format(new Date(article.created_at), "d MMMM yyyy", { locale: dateLocale })}
            </span>
          </div>
          <h1 className="text-2xl md:text-4xl font-semibold text-white leading-snug">{article.title}</h1>
        </div>
      </section>

      {/* Contenu */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <Link
            to="/actualites"
            className="inline-flex items-center gap-2 text-[#2547a8] text-sm font-medium mb-10 hover:gap-3 transition-all duration-300"
            data-testid="news-back-link"
          >
            <ArrowLeft size={16} /> {tn.back}
          </Link>
          {article.content.split(/\n\n+/).map((p, i) => (
            <p key={i} className="text-slate-700 leading-loose font-light mb-6 text-[16px]">
              {p}
            </p>
          ))}
        </div>
      </section>
    </div>
  );
};

export default NewsDetail;
